const DEFAULT_IMAGE_QUALITY = 75
const SQUARE_IMAGE_MAX_WIDTH = 330
export const widthHeightQuality = (width, height, quality = DEFAULT_IMAGE_QUALITY, isSquare = false) => {
  return isSquare ? `_w${width}_square` : `_w${width}_h${height}_q${quality}`
}

export const addPrefixThumbnail = (url) => {
  return `https://${url.replace('https://', '').replace('http://', '')}`
}

export const resize = (url, { width, height, quality = DEFAULT_IMAGE_QUALITY, isSquare = false }) => {
  let urlArr = url.split('.')
  let postfix = urlArr.pop()
  return `${urlArr.join('.')}${widthHeightQuality(width, height, quality, isSquare)}.${postfix}`
}

export const resizeThumbnail = (url, { width, height, quality = DEFAULT_IMAGE_QUALITY, isSquare = false }) => {
  let completedUrl = addPrefixThumbnail(url)
  return resize(completedUrl, { width: (isSquare ? SQUARE_IMAGE_MAX_WIDTH : width * 2), height: height * 2, quality, isSquare })
}
